module.exports = __webpack_public_path__ + "df620292b47153f718f4de237416f2a0.svg";